import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gtd-ui-field-user-status',
  templateUrl: './status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusComponent {
  @Input() customClass = '';
  @Input() set data(value) {
    switch (value) {
      case 0:
      case '0':
        this.status = $localize`:@@common.pending:Pending`;
        break;
      case 1:
      case '1':
        this.status = $localize`:@@common.active:Active`;
        break;
      case 2:
      case '2':
        this.status = $localize`:@@common.blocked:Blocked`;
        break;
      default:
        this.status = $localize`:@@common.unknown:Unknown`;
    }
  }

  public status: string;
}
